import type { Middleware } from '@reduxjs/toolkit';

export const actionToPlainObject: Middleware = () => (next) => (action) => {
  if (!action) return;
  return next({ ...(action as Record<string, unknown>) });
};
